import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
} from "../../../../components";
import { useColunaFilial } from "../../../../components/dataGrid/use-coluna-filial";

function HistoricoPagamentos({
  dadosPagamentoList,
  dadosPagamentoColunas,
  openHistorico,
  handleHistorico,
}) {
  const historicoPagamentos = dadosPagamentoList.filter(item => !item.deletedAt);
  const colunas = useColunaFilial(dadosPagamentoColunas, openHistorico);

  return (
    <Dialog
      maxWidth={"xl"}
      fullWidth
      open={openHistorico}
      onClose={handleHistorico}
    >
      <DialogContent>
        <CardHeader
          title="Histórico de Baixas "
          action={
            <Button
              onClick={handleHistorico}
              variant="contained"
              color="padrao"
            >
              fechar
            </Button>
          }
        />
        <Grid container spacing={4}>
          <Grid className="mt-2" item xs={12}>
            <DataGrid
              rows={historicoPagamentos}
              columns={colunas}
              rowCount={dadosPagamentoList.length}
              disableAcoes
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
}

export default HistoricoPagamentos;
